<template>
  <div>
    <v-list-item
      :disabled="!cuentaSelected || inactivo || cerrada"
      @click="onSubmit"
    >
      <v-list-item-icon>
        <v-icon>mdi-keyboard-f4</v-icon>
      </v-list-item-icon>
      <v-list-item-title>Imprimir deuda</v-list-item-title>
      <v-list-item-icon>
        <v-icon>mdi-printer</v-icon>
      </v-list-item-icon>
    </v-list-item>
  </div>
</template>

<script>
import { generateEncabezado } from '@/pages/cuentas/pdf_encabezado.js';
import { generateDatosCliente } from '@/pages/cuentas/pdf_datos_cliente.js';
import FormatDecimalMixin from '@/mixins/FormatDecimal';
import PrecioMixin from '@/mixins/Precios';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
pdfMake.vfs = pdfFonts;

export default {
  name: 'ResumenPrintComponent',
  mixins: [FormatDecimalMixin, PrecioMixin],
  data () {
    return {
      loading: false,
      qrPath: 'public/images/qr.png',
      empresa: {
        razon_social: 'SARTINI GAS S.R.L.',
        cuit: '30-59748997-4',
        ing_brutos: '101926A',
        domicilio: 'Heroes de malvinas 4620',
        telefonos: ['(2901) 64-2929', '(2901) 61-6580'],
        localidad: 'Ushuaia - Tierra del Fuego',
        actividades: '01/01/1983',
        condicion_iva: 'IVA Responsable Inscripto'
      },
    }
  },
  beforeMount () {
    window.addEventListener('keydown', this.handleKeyboard);
  },
  beforeDestroy () {
    window.removeEventListener('keydown', this.handleKeyboard);
  },
  computed: {
    inactivo () {
      return this.$store.getters['Cuentas/inactivo']
    },
    cerrada () {
      return this.$store.getters['Cuentas/cerrada']
    },
    transacciones () {
      return this.$store.getters['Transacciones/all']
    },
    saldoUsuario() {
      return this.cuenta.saldo_usuario
    },
    saldoPleno() {
      return (this.cuenta.kilos_pleno * this.precioByVigencia(this.$moment().format('YYYY-MM-DD')).pleno) + this.cuenta.saldo_pleno
    },
    saldoTotal() {
      return this.saldoPleno + this.saldoUsuario;
    },
    saldoCompleto() {
      if (this.saldoTotal == 0 && this.saldoAFavor > 0) {
        return '+' + this.formatToTwoDecimals(this.saldoAFavor);
      }
      return this.formatToTwoDecimals(this.saldoTotal);
    },
    cuenta () {
      return this.$store.getters['Cuentas/selected']
    },
    cuentaSelected () {
      return this.cuenta && this.cuenta.id > 0;
    },
    saldoAFavor() {
      return this.cuenta.credito_demas
    },
    kilosSubsidio() {
      const precio = this.precioByVigencia(this.$moment().format('YYYY-MM-DD')).subsidio;
      return this.cuenta.saldo_subsidio ? (this.cuenta.saldo_subsidio / precio) : 0
    },
  },
  methods: {
    async onSubmit () {
      const win = window.open('', '_blank');
      try {
        this.loading = true;
        // Verificamos la ruta del QR
        if (!this.qrPath) {
          console.warn('Ruta del QR no definida, el PDF se generará sin QR.');
        }
        const fecha = this.$moment(this.$store.getters['Saldos/selected'].periodo).format('MMMM/YYYY');
        const encabezado = generateEncabezado(this.empresa);
        const datosCliente = generateDatosCliente(this.cuenta);
        const datosSaldo = {
          alignment: 'justify',
          stack: [
            { text: 'Saldo total $ ' + this.saldoCompleto, style: 'subheader' },
            ...(this.saldoTotal == 0 ? [] : [{ text: 'deuda subsidio $ ' + this.formatToTwoDecimals(this.saldoUsuario) + ' + deuda sin subsidio $ ' + this.formatToTwoDecimals(this.saldoPleno), style: 'saldos' }]),
            { text: 'Kilos subsidiados a favor ' + this.formatToThreeDecimals(this.kilosSubsidio) },
            { text: '(Calculado al precio actual y sujeto a variaciones de precios)', style: 'saldos' },
          ]
        };
        const datosTransacciones = {
          table: {
            headerRows: 1,
            widths: ['13%', '25%', '14%', '*', '*'],
            body: [
              [
                { text: 'Fecha', style: 'tableHeader' },
                { text: 'Descripción', style: 'tableHeader' },
                { text: 'Kilos', style: 'tableHeader' },
                { text: 'Importe', style: 'tableHeader' },
                { text: 'Saldo', style: 'tableHeader' }
              ],
              ...this.transacciones.map((item) => [
                { text: (item.fecha ? this.$moment(item.fecha).format('DD/MM/YYYY') : ''), style: 'fecha' },
                { text: item.transaccion_detalle || 'Sin descripción', style: 'detalle' },
                { text: (this.formatToThreeDecimals(item.cantidad) || '0,000'), style: 'cantidad' },
                { text: '$ ' + (this.formatToTwoDecimals(item.transaccion_tipo == 'Bono' ? 0 : item.importe) || '0,00'), style: 'importe' },
                { text: '$ ' + (this.formatToTwoDecimals(item.cuenta_saldo) || '0,00'), style: 'saldo' },
              ]),
            ],
          },
          margin: [0, 5, 0, 10],
        };

        const docDefinition = {
          content: [
            encabezado,
            { text: '' },
            datosCliente,
            datosSaldo,
            { text: 'Resumen', style: 'resumen' },
            this.transacciones && this.transacciones.length > 0 ? datosTransacciones : 'No hay transacciones.',
          ],
          footer: (currentPage, pageCount) => ({
            columns: [
              { text: this.$moment().format('DD/MM/YYYY'), style: 'leftAlign' },
              { text: `Página ${currentPage} de ${pageCount}`, style: 'rightAlign' },
              // base64Image
              //   ? {
              //       image: base64Image,
              //       width: 60, // Ajusta el tamaño del QR
              //       alignment: 'right',
              //       margin: [0, 5, 10, 0],
              //     }
                // : '', // No se muestra nada si no hay QR disponible
            ],
          }),
          styles: {
            clienteTitulo: { fontSize: 12, margin: [0, 10, 0, 0] },
            header: { fontSize: 18, bold: true },
            resumen: { fontSize: 12, bold: true, margin: [0, 10, 0, 5] },
            saldos: { fontSize: 10, margin: [0, 0, 0, 5] },
            fecha: { fontSize: 10, alignment: 'center' },
            detalle: { fontSize: 10, alignment: 'center' },
            cantidad: { fontSize: 11, alignment: 'center' },
            importe: { fontSize: 11, alignment: 'right' },
            saldo: { fontSize: 11, alignment: 'right' },
            subheader: { fontSize: 15, bold: true, margin: [0, 10, 0, 5] },
            sectionTitle: { fontSize: 12, bold: true, margin: [0, 10, 0, 5] },
            footer: { fontSize: 10, italics: true, margin: [0, 20, 0, 0] },
            rightAlign: { alignment: 'right', margin: [0, 5, 40, 0] },
            leftAlign: { alignment: 'left', margin: [35, 5, 0, 0] },
            tableHeader: { fontSize: 10, alignment: 'left' },
          },
          images: {
            snow: 'https://criticasur.com.ar/uploads/noticias/5/20170615191830_sartini_gas.jpg',
            // snow: {
              // //
            // }
          }
        };
        // Generar e imprimir el PDF
        if (win) {
          pdfMake.createPdf(docDefinition).print({}, win);
        } else {
          pdfMake.createPdf(docDefinition).print();
        }
      } catch (error) {
        console.error('Error al generar el PDF:', error);
        if (win) win.close();
      } finally {
        this.loading = false;
      }
    },
    handleKeyboard (event) {
      const actions = {
        F4: this.onSubmit,
      };

      if (!event.ctrlKey && this.cuentaSelected && actions[event.key]) {
        event.preventDefault()
        actions[event.key].call(this, event);
      }
      else if (!event.ctrlKey && !this.cuentaSelected && actions[event.key]) {
        event.preventDefault()
        alert('Primero debe seleccionar una cuenta y un periodo!')
      }
    },
    onDetalleSaldos(item) {
      if(item == null) return 0;
      return item.demas - item.pleno_total - item.usuario;
    },
  },

}
</script>
